const bars = document.querySelectorAll('[data-sale-end]');

const pad = (value) => String(value).padStart(2, '0');

const tick = (bar) => {
  const end = Date.parse(bar.getAttribute('data-sale-end') || '');
  const remaining = Number.isNaN(end) ? 0 : Math.max(0, end - Date.now());
  const totalSeconds = Math.floor(remaining / 1000);
  const values = {
    day: Math.floor(totalSeconds / 86400),
    hrs: Math.floor(totalSeconds / 3600) % 24,
    min: Math.floor(totalSeconds / 60) % 60,
    sec: totalSeconds % 60,
  };

  Object.entries(values).forEach(([unit, value]) => {
    const node = bar.querySelector(`[data-unit="${unit}"]`);
    if (node) node.textContent = pad(value);
  });
};

bars.forEach((bar) => {
  tick(bar);
  window.setInterval(() => tick(bar), 1000);
});
